import React, {Fragment} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {Glyphicon} from './GlyphIcon';
import {usePublic} from "../../Hooks/PermissionHooks";

export const InfoIcon = (props) => {
    const isPublic = usePublic();
    let {
        backgroundColor,
        children,
        id = null,
        placement = "right",
        className = 'info-icon',
        glyph='info-sign'
    } = props;

    if (isPublic) return null;
    
    if(id == null) {
        if(children != null && children.innerText) {
            id = children.innerText.replace(/ /g, "-");
        } else if(children != null && typeof children == "string") {
            id = children.replace(/ /g, "-");
        }
    }
    
    // "learn more:" style info links
    if(props.link) {
        children = <Fragment>
            <span className="title"><Glyphicon className="learn-more-icon" glyph="share" />Learn More:</span>
            <div className="content">{children}</div>
        </Fragment>;
    }

    if(id && children) {
        let tooltip = <Tooltip id={"sb-info-icon-tooltip-" + id} className={className}>{children}</Tooltip>;
        
        let glyphicon = <Glyphicon className={className} glyph={glyph} />;
        
        // if we have a link, wrap the icon in a link
        if(props.link) {        
            glyphicon = <a className="link-primary" href={props.link} target="_blank">
                {glyphicon}
            </a>;
        }

        return <Fragment>
            {' '}
            <OverlayTrigger placement={placement} overlay={tooltip}>
                <span>{glyphicon}</span>
            </OverlayTrigger>
        </Fragment>;
    }

    return null;
};


